export enum AuthRole {
    EXT = 'EXT',
    AUDITOR = 'AUDITOR',
    EXT_AUDITOR = 'EXT_AUDITOR',
    EXT_CURVE = 'EXT_CURVE',
    MANAGER = 'MANAGER',
    EO = 'EO',
    GBO = 'GBO'
}
